import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Nofind from './views/404'
import CertResult from './views/CertResult'
import ComCertResult from './views/ComCertResult'
import PdfShow from './views/PdfShow'
import Cert from './views/Cert'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: "selected",
  base: process.env.BASE_URL,
  routes: [{
      path: '*',
      name: '/404',
      component: Nofind
    },{
      path: '/createCert',
      name: 'createCert',
      component: Cert
    }, {
      path: '/standard',
      name: 'showpdf',
      component: PdfShow
    }, {
      path: '/certResult',
      name: 'certResult',
      component: CertResult
    }, {
      path: '/comCertResult',
      name: 'comCertResult',
      component: ComCertResult
    },
    {
      path: '/',
      name: 'index',
      component: Index
    }, {
      path: '/:id',
      name: 'index',
      component: Index
    }
  ]
})

// // 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = localStorage.eleToken ? true : false;
//   if (to.path == "/login" || to.path == "/register") {
//     next();
//   } else {
//     isLogin ? next() : next("/login");
//   }
// })
// let router = createRouter({
//   history: createWebHistory(),
//   routes,
//   linkExactActiveClass: "selected"
// })
export default router;